export default __webpack_public_path__ + "static/partners06-5f4f8717ed4b33ed9e243f0aa9c3e50d.svg";